<template>
  <div class="kui-form">
    <slot></slot>
  </div>
</template>
<script>
import form from "./src/form";
export default form;
</script>
<style lang='less' scoped>
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/form/index.vue